export function createArray(length: any): unknown[] {
  // eslint-disable-next-line prefer-spread
  return Array.apply(null, { length } as any);
}

export function keysToArray(obj: any) {
  const keys = Object.keys(obj);
  return keys.map((key) => key);
}

export function propsToArray(obj: any) {
  const keys = Object.keys(obj);
  return keys.map((key) => obj[key]);
}

/**
 * Check if all the fields are completely empty or completely filled.
 *
 * @param {array of string or number} list - list containing input field values
 * @param {} originalList? - original list to compare the list with
 * @returns {boolean} true if list is completely empty or completely filled. False otherwise.
 */
export function checkForCompletnessOrAllEmpty(list: any, originalList: any) {
  const olistLength = (originalList && originalList.length) ? originalList.length : list.length;
  const filteredList = list.filter((item: any) => (item || item === 0) && !!item.toString().trim());
  return !!((filteredList.length === 0 || filteredList.length === olistLength));
}

export function createGrid<T>(list: T[], cols: number): T[][] {
  const grid: T[][] = [];
  let row: T[] = [];
  for (let i = 0; i <= list.length; i += 1) {
    if ((i % cols === 0 || i === list.length) && row.length) {
      grid.push(row);
      row = [];
    }
    row.push(list[i]);
  }
  return grid;
}

export function getLastSortIndex<T>(arr?: T extends { ['sortIndex']: number } ? T[] : never) {
  if (!arr || arr.length < 1) {
    return 0;
  }
  return arr[arr.length - 1].sortIndex + 1;
}
